"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Flex = _interopRequireDefault(require("../../Components/Flex"));
var _Link = _interopRequireDefault(require("../../Components/Link"));
var _String = _interopRequireDefault(require("../../Components/String"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Invalid URI view
 *
 * The "URI not found" (404) view.
 * 
 * @package HOPS
 * @subpackage Errors
 * @copyright Heritage Operations Processing Limited
 */const InvalidUriView = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
    px: 1,
    py: 1,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
      bold: true,
      str: "Invalid URI",
      variant: "h5"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
      color: "textSecondary",
      str: "Please check the link you used to reach this screen."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
      endArrow: true,
      label: "Back to Home",
      uri: "/"
    })]
  });
};
var _default = exports.default = InvalidUriView;